module.exports = __webpack_public_path__ + "img/2.aa132797.png";